export const testLoadDataSets = {
  listedFreight: {
    name: "Listed Freight Load",
    description: "Минимальный Freight Load со статусом Listed",
    data: {
      orderId: `TEST-FREIGHT-${Date.now()}`,
      status: "Listed",
      customer: {
        companyName: "Test Freight Customer",
        email: "test-freight-customer@example.com",
        type: "customer",
        customerAddress: {
          address: "123 Test Street",
          city: "Los Angeles",
          state: "CA",
          zipCode: "90001"
        },
        phoneNumber: "+1234567890"
      },
      customerEmails: ["test-freight-customer@example.com"],
      customerRate: "1500",
      carrierRate: "1200",
      paymentMethod: "ACH",
      paymentTerms: "15",
      type: {
        freight: true,
        vehicle: false
      },
      freight: {
        shipment: [
          {
            description: "Test Freight Shipment",
            weight: "5000",
            quantity: "1",
            value: "10000"
          }
        ],
        freightImages: []
      },
      vehicle: {
        shipment: [],
        specialRequirements: "",
        vehicleImages: []
      },
      pickup: {
        locationName: "Test Pickup Warehouse",
        address: {
          address: "456 Pickup Avenue",
          city: "Los Angeles",
          state: "CA",
          zipCode: "90002"
        },
        contactPhone: "+1234567891",
        notes: "Test pickup notes",
        date: "",
        images: []
      },
      delivery: {
        locationName: "Test Delivery Warehouse",
        address: {
          address: "789 Delivery Boulevard",
          city: "San Francisco",
          state: "CA",
          zipCode: "94102"
        },
        contactPhone: "+1234567892",
        notes: "Test delivery notes",
        date: "",
        images: []
      },
      dates: {
        assignedDate: "",
        deadline: "",
        pickupDate: "",
        pickupDateType: "Exact",
        pickupDateStart: "",
        pickupDateEnd: "",
        deliveryDate: "",
        deliveryDateType: "Exact",
        deliveryDateStart: "",
        deliveryDateEnd: "",
        aging: ""
      },
      carrier: {
        id: "",
        name: "",
        phoneNumber: "",
        email: "",
        companyName: "",
        mcNumber: "",
        dotNumber: "",
        address: {
          address: "",
          city: "",
          state: "",
          zipCode: ""
        },
        equipment: [],
        equipmentType: [],
        size: [],
        capabilities: [],
        certifications: []
      },
      carrierEmails: [],
      carrierPhotos: [],
      insurance: {
        type: "",
        customAmount: ""
      },
      fees: [],
      tonu: {
        enabled: false,
        carrierRate: "",
        customerRate: ""
      },
      tracking: "",
      documents: [],
      images: [],
      pdfs: []
    }
  },
  listedVehicle: {
    name: "Listed Vehicle Load",
    description: "Минимальный Vehicle Load со статусом Listed",
    data: {
      orderId: `CC-00`,
      status: "Listed",
      customer: {
        companyName: "Test Vehicle Customer",
        email: "test-vehicle-customer@example.com",
        type: "customer",
        customerAddress: {
          address: "321 Vehicle Road",
          city: "New York",
          state: "NY",
          zipCode: "10001"
        },
        phoneNumber: "+1234567893"
      },
      customerEmails: ["test-vehicle-customer@example.com"],
      customerRate: "2000",
      carrierRate: "1600",
      paymentMethod: "Wire",
      paymentTerms: "30",
      type: {
        freight: true,
        vehicle: false
      },
  freight: {
    shipment: [
      {
        commodity: "Commodity",
        dimensionsLength: "80",
        dimensionsWidth: "60",
        dimensionsHeight: "80",
        weight: "5000",
        poNumber: "4524",
        pickupNumber: "366541",
        deliveryReference: "654654"
      },
      {
        commodity: "Commodity",
        dimensionsLength: "50",
        dimensionsWidth: "60",
        dimensionsHeight: "50",
        weight: "5070",
        poNumber: "75764",
        pickupNumber: "4545876",
        deliveryReference: "5686"
      },
      {
        commodity: "Commodity",
        dimensionsLength: "50",
        dimensionsWidth: "60",
        dimensionsHeight: "70",
        weight: "4550",
        poNumber: "45457",
        pickupNumber: "6868863",
        deliveryReference: "8686854"
      },
      {
        commodity: "Commodity",
        dimensionsLength: "50",
        dimensionsWidth: "50",
        dimensionsHeight: "60",
        weight: "5000",
        poNumber: "45545",
        pickupNumber: "64646",
        deliveryReference: "46466"
      }
    ],
  },
     
      pickup: {
        locationName: "Test Vehicle Pickup",
        address: {
          address: "654 Vehicle Street",
          city: "New York",
          state: "NY",
          zipCode: "10002"
        },
        contactPhone: "+1234567894",
        notes: "Vehicle pickup notes",
        date: "",
        images: []
      },
      delivery: {
        locationName: "Test Vehicle Delivery",
        address: {
          address: "987 Vehicle Lane",
          city: "Boston",
          state: "MA",
          zipCode: "02101"
        },
        contactPhone: "+1234567895",
        notes: "Vehicle delivery notes",
        date: "",
        images: []
      },
      dates: {
        assignedDate: "",
        deadline: "",
        pickupDate: "",
        pickupDateType: "Exact",
        pickupDateStart: "",
        pickupDateEnd: "",
        deliveryDate: "",
        deliveryDateType: "Exact",
        deliveryDateStart: "",
        deliveryDateEnd: "",
        aging: ""
      },
      carrier: {
        id: "",
        name: "",
        phoneNumber: "",
        email: "",
        companyName: "",
        mcNumber: "",
        dotNumber: "",
        address: {
          address: "",
          city: "",
          state: "",
          zipCode: ""
        },
        equipment: [],
        equipmentType: [],
        size: [],
        capabilities: [],
        certifications: []
      },
      carrierEmails: [],
      carrierPhotos: [],
      insurance: {
        type: "",
        customAmount: ""
      },
      fees: [],
      tonu: {
        enabled: false,
        carrierRate: "",
        customerRate: ""
      },
      tracking: "",
      documents: [],
      images: [],
      pdfs: []
    }
  },
  listedFreightWithDates: {
    name: "Listed Freight with Dates",
    description: "Freight Load с заполненными датами",
    data: {
      orderId: "CC-0001",
      customerEmails: [
        "test-dates@example.com",
        "rkeveyan@list.ru",
        "rkeveyan23@gmail.com"
      ],
      customerRate: "1800",
      carrierRate: "1400",
      type: {
        freight: true,
        vehicle: false
      },
      freight: {
        shipment: [
          {
            commodity: "fdgfdg",
            dimensionsLength: "56",
            dimensionsWidth: "56",
            dimensionsHeight: "80",
            weight: "6000"
          }
        ],
        pdfs: [],
      },
      pickup: {
        locationName: "Pickup with Date",
        address: {
          address: "222 Pickup Road",
          city: "Chicago",
          state: "IL",
          zipCode: "60602"
        },
        contactPhone: "+1234567897",
        date: "2026-02-20T00:00:00.000Z",
      },
      delivery: {
        locationName: "Delivery with Date",
        address: {
          address: "333 Delivery Avenue",
          city: "Detroit",
          state: "MI",
          zipCode: "48201"
        },
        contactPhone: "+1234567898",
        date: "2026-02-23T00:00:00.000Z",
      },
      carrierEmails: [
        "galaxysystems2025@gmail.com"
      ],
      insurance: {
        type: "$100000"
      },
      status: "Delivered",
      dates: {
        assignedDate: "2026-02-13T00:00:00.000Z",
        deadline: "2026-02-27T00:00:00.000Z",
        pickupDate: "2026-02-13T00:00:00.000Z",
        pickupDateType: "Exact",
        deliveryDate: "2026-02-14T00:00:00.000Z",
        deliveryDateType: "Exact"
      },
      fees: [],
      tonu: {
        enabled: false
      },
      paymentMethod: "ACH",
      paymentTerms: "1",
      images: [],
      pdfs: [],
    }
  },
  fullVehicleLoad: {
    name: "Full Vehicle Load",
    description: "Полный Vehicle Load со всеми заполненными полями",
    data: {
      orderId: `TEST-VEHICLE-FULL-${Date.now()}`,
      status: "Listed",
      customer: {
        companyName: "Premium Vehicle Transport Inc",
        email: "premium-vehicle@example.com",
        type: "customer",
        customerAddress: {
          address: "789 Vehicle Transport Boulevard",
          city: "Miami",
          state: "FL",
          zipCode: "33101"
        },
        phoneNumber: "+13055551234"
      },
      customerEmails: [
        "premium-vehicle@example.com",
        "contact@premium-vehicle.com"
      ],
      customerRate: "3500",
      carrierRate: "2800",
      paymentMethod: "Wire",
      paymentTerms: "30",
      type: {
        freight: false,
        vehicle: true
      },
      freight: {
        shipment: [],
        freightImages: []
      },
      vehicle: {
        shipment: [
          {
            vin: "1HGBH41JXMN109186",
            make: "Toyota",
            model: "Camry",
            year: "2023",
            value: "28000"
          },
          {
            vin: "5YJSA1E11HF123456",
            make: "Tesla",
            model: "Model 3",
            year: "2024",
            value: "45000"
          },
          {
            vin: "WBA3A5C58EF123789",
            make: "BMW",
            model: "X5",
            year: "2022",
            value: "55000"
          }
        ],
        specialRequirements: "All vehicles must be transported in enclosed trailers. No smoking in transport vehicles. Keys must be provided for each vehicle.",
        vehicleImages: []
      },
      pickup: {
        locationName: "Miami Auto Dealership",
        address: {
          address: "1234 Ocean Drive",
          city: "Miami Beach",
          state: "FL",
          zipCode: "33139"
        },
        contactPhone: "+13055552345",
        notes: "Pickup from main dealership lot. Contact John Smith upon arrival. Vehicles are ready for transport.",
        date: "2026-02-25T08:00:00.000Z",
        images: []
      },
      delivery: {
        locationName: "Los Angeles Auto Center",
        address: {
          address: "5678 Sunset Boulevard",
          city: "Los Angeles",
          state: "CA",
          zipCode: "90028"
        },
        contactPhone: "+12135553456",
        notes: "Deliver to rear loading dock. Contact warehouse manager Jane Doe. Business hours: 8 AM - 6 PM.",
        date: "2026-03-01T14:00:00.000Z",
        images: []
      },
      dates: {
        assignedDate: "2026-02-20T00:00:00.000Z",
        deadline: "2026-03-05T00:00:00.000Z",
        pickupDate: "2026-02-25T08:00:00.000Z",
        pickupDateType: "Exact",
        pickupDateStart: "",
        pickupDateEnd: "",
        deliveryDate: "2026-03-01T14:00:00.000Z",
        deliveryDateType: "Exact",
        deliveryDateStart: "",
        deliveryDateEnd: "",
        aging: ""
      },
      carrier: {
        id: "",
        name: "John Driver",
        phoneNumber: "+13055554567",
        email: "john.driver@carrier.com",
        companyName: "Elite Auto Transport LLC",
        mcNumber: "MC-123456",
        dotNumber: "DOT-789012",
        address: {
          address: "456 Carrier Street",
          city: "Orlando",
          state: "FL",
          zipCode: "32801"
        },
        equipment: ["Enclosed Trailer"],
        equipmentType: ["Auto Transport"],
        size: ["48ft"],
        capabilities: ["Enclosed Transport", "Multi-Car"],
        certifications: ["DOT Certified"]
      },
      carrierEmails: [
        "john.driver@carrier.com",
        "dispatch@elite-auto.com"
      ],
      carrierPhotos: [],
      insurance: {
        type: "$250000",
        customAmount: ""
      },
      fees: [
        {
          name: "Fuel Surcharge",
          amount: "150",
          type: "carrier"
        },
        {
          name: "Toll Fees",
          amount: "85",
          type: "customer"
        }
      ],
      tonu: {
        enabled: true,
        carrierRate: "500",
        customerRate: "600"
      },
      tracking: "TRACK-2026-VEH-001",
      documents: [],
      images: [],
      pdfs: []
    }
  },
  mixedFullLoad: {
    name: "Mixed Full Load",
    description: "Смешанный тип Load (Freight + Vehicle) со всеми заполненными полями",
    data: {
      orderId: `TEST-MIXED-FULL-${Date.now()}`,
      status: "Listed",
      customer: {
        companyName: "Universal Logistics Solutions",
        email: "universal-logistics@example.com",
        type: "customer",
        customerAddress: {
          address: "999 Commerce Plaza",
          city: "Atlanta",
          state: "GA",
          zipCode: "30309"
        },
        phoneNumber: "+14045555678"
      },
      customerEmails: [
        "universal-logistics@example.com",
        "operations@universal-logistics.com",
        "billing@universal-logistics.com"
      ],
      customerRate: "5200",
      carrierRate: "4200",
      paymentMethod: "ACH",
      paymentTerms: "15",
      type: {
        freight: true,
        vehicle: true
      },
      freight: {
        shipment: [
          {
            commodity: "Electronics Equipment",
            dimensionsLength: "120",
            dimensionsWidth: "48",
            dimensionsHeight: "72",
            weight: "8500",
            poNumber: "PO-2026-001",
            pickupNumber: "PICK-456789",
            deliveryReference: "DEL-789012",
            quantity: "10",
            value: "25000"
          },
          {
            commodity: "Furniture",
            dimensionsLength: "96",
            dimensionsWidth: "36",
            dimensionsHeight: "60",
            weight: "3200",
            poNumber: "PO-2026-002",
            pickupNumber: "PICK-456790",
            deliveryReference: "DEL-789013",
            quantity: "5",
            value: "8500"
          }
        ],
        freightImages: []
      },
      vehicle: {
        shipment: [
          {
            vin: "1FTFW1ET5MFC12345",
            make: "Ford",
            model: "F-150",
            year: "2021",
            value: "35000"
          },
          {
            vin: "JTMBRFREXMD123456",
            make: "Toyota",
            model: "RAV4",
            year: "2023",
            value: "32000"
          }
        ],
        specialRequirements: "Vehicles must be secured separately from freight. Use proper tie-downs. Freight should not come into contact with vehicles.",
        vehicleImages: []
      },
      pickup: {
        locationName: "Atlanta Distribution Center",
        address: {
          address: "2345 Industrial Parkway",
          city: "Atlanta",
          state: "GA",
          zipCode: "30318"
        },
        contactPhone: "+14045556789",
        notes: "Main warehouse entrance. Dock 3-5 available. Forklift assistance available. Loading hours: 7 AM - 5 PM. Contact warehouse supervisor Mike Johnson.",
        date: "2026-02-28T09:00:00.000Z",
        images: []
      },
      delivery: {
        locationName: "Dallas Mega Center",
        address: {
          address: "6789 Logistics Way",
          city: "Dallas",
          state: "TX",
          zipCode: "75201"
        },
        contactPhone: "+12145557890",
        notes: "Use Gate B for entry. Dock 12-15 for freight, separate area for vehicles. Security checkpoint required. Contact Sarah Williams for delivery coordination.",
        date: "2026-03-03T11:00:00.000Z",
        images: []
      },

      carrier: {
        id: "",
        name: "Robert Carrier",
        phoneNumber: "+12145558901",
        email: "robert.carrier@transport.com",
        companyName: "Multi-Modal Transport Services",
        mcNumber: "MC-234567",
        dotNumber: "DOT-890123",
        address: {
          address: "789 Transport Avenue",
          city: "Nashville",
          state: "TN",
          zipCode: "37203"
        },
        equipment: ["Flatbed", "Enclosed Trailer", "Box Truck"],
        equipmentType: ["Freight", "Auto Transport"],
        size: ["48ft", "53ft"],
        capabilities: ["Mixed Loads", "LTL", "FTL", "Auto Transport"],
        certifications: ["DOT Certified", "Hazmat Certified"]
      },
      carrierEmails: [
        "robert.carrier@transport.com",
        "dispatch@multi-modal.com",
        "safety@multi-modal.com"
      ],
      carrierPhotos: [],
      insurance: {
        type: "$500000",
        customAmount: ""
      },
      fees: [
        {
          name: "Lumper Fee",
          amount: "200",
          type: "customer"
        },
        {
          name: "Detention",
          amount: "150",
          type: "carrier"
        },
        {
          name: "Scale Ticket",
          amount: "25",
          type: "customer"
        }
      ],
      tonu: {
        enabled: true,
        carrierRate: "800",
        customerRate: "1000"
      },
      tracking: "TRACK-2026-MIX-001",
      documents: [],
      images: [],
      pdfs: []
    }
  }
};

export const getTestDataSet = (key) => {
  return testLoadDataSets[key] || null;
};

export const getAllTestDataSets = () => {
  return Object.keys(testLoadDataSets).map(key => ({
    key,
    ...testLoadDataSets[key]
  }));
};
